export default __webpack_public_path__ + "static/media/web_flash.49835920.svg";